import { render, staticRenderFns } from "./PowerBiIframe.vue?vue&type=template&id=05f5f8e6&scoped=true"
import script from "./PowerBiIframe.vue?vue&type=script&lang=js"
export * from "./PowerBiIframe.vue?vue&type=script&lang=js"
import style0 from "./PowerBiIframe.vue?vue&type=style&index=0&id=05f5f8e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05f5f8e6",
  null
  
)

export default component.exports